<template>
  <div class="app-deactivate-auto-top-up" v-if="autoTopUp.topUp">
    <div class="text"><slot name="txtBeforeDeactivateAutoTopup"></slot></div>
    <div class="beforeActiveAutoTopup"><slot name="txtBeforeActiveAutoTopup">Sie haben aktuell folgende automatische Aufladung eingerichtet:</slot></div>
    <div class="activeAutoTopup">
      <div v-if = "autoTopUp.topUp.type === 'DAY_OF_MONTH'">
        <dyn-slot :slot-data="slotData">
        <slot name="txtActiveAutoTopUpDayOfMonth">An jedem {{autoTopUp.topUp.trigger}}. eines Monats werden automatisch {{formatedAmount}} auf Ihr Konto aufgebucht.</slot>
        </dyn-slot>
      </div>
      <div v-if = "autoTopUp.topUp.type === 'ACCOUNT_BALANCE'">
        <dyn-slot :slot-data="slotData">
        <slot name="txtActiveAutoTopUpAccountBalance">Bei einer Guthabenuntergrenze von {{formatedTrigger}} werden automatisch  {{formatedAmount}} auf Ihr Konto aufgebucht.</slot>
        </dyn-slot>
      </div>
    </div>
    <b-form
      class="deactivate-auto-top-up-form"
      :id="'form' + _uid"
      >
      <b-form-checkbox
        v-model="deactivate"
        class="deactivate-top-up"
        required
        @input="$v.deactivate.$touch"
        :state="isValid('deactivate')"
      >
        <div class="mandatory"><slot name="lblDeaktivateAutoTopUp">Ja, ich möchte die automatische Aufladung deaktivieren.</slot></div>
      </b-form-checkbox>
      <b-overlay class="btn-next-overlay" :show="loading" spinner-small>
        <b-button v-on:click="deactivateTopUp" class="btn-next" type="button" variant="primary" :disabled="$v.$invalid || loading">
          <slot name="btnNext">Automatische Aufladung deaktivieren</slot>
        </b-button>
      </b-overlay>
    </b-form>
  </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import processSteps from '../../../../../mixins/processSteps'
import isValid from '../../../../../mixins/isValid'
import { sameAs } from 'vuelidate/lib/validators'
import { mapActions } from 'vuex'
import { stepName as nextProcessStep } from '../../../../generic/Success2.vue'
import price from '@/mixins/price'

export const stepName = 'deactivate'
export default {
  name: 'DeactivateAutoTopUp',
  data () {
    return {
      deactivate: false,
      loading: false
    }
  },
  computed: {
    formatedAmount () {
      return this.price(this.autoTopUp.topUp.amount)
    },
    formatedTrigger () {
      return this.price(this.autoTopUp.topUp.trigger)
    },
    slotData () {
      return {
        formattedAmount: this.formatedAmount,
        formattedTrigger: this.formatedTrigger
      }
    }
  },
  methods: {
    deactivateTopUp () {
      this.loading = true
      this.deactivateAutoTopUp(nextProcessStep).then(() => {
        this.loading = false
      }, () => {
        this.loading = false
      })
    },
    ...mapActions('topUp', [
      'deactivateAutoTopUp'
    ])
  },
  mixins: [
    validationMixin,
    isValid,
    price,
    processSteps(stepName, stepName, nextProcessStep)
  ],
  validations () {
    return {
      deactivate: {
        sameAs: sameAs(() => true)
      }
    }
  },
  props:
    [
      'autoTopUp'
    ]
}
</script>
